(function () {
  "use strict";

  var allowed = /^(gclid|gbraid|wbraid|fbclid|msclkid|utm_[a-z0-9_]+)$/i;

  function trackingParams() {
    var params = new URLSearchParams();
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (allowed.test(key)) params.set(key, value);
    });
    return params;
  }

  function carryTracking() {
    var params = trackingParams();
    if (!params.toString()) return;
    document.querySelectorAll('a[href^="/pages/mini-book-ornament-advent-calendar-product"]').forEach(function (link) {
      var target = new URL(link.getAttribute("href"), window.location.origin);
      params.forEach(function (value, key) { target.searchParams.set(key, value); });
      link.setAttribute("href", target.pathname + target.search + target.hash);
    });
  }

  function repairProtectedEmail() {
    document.querySelectorAll('a[href*="email-protection"], [data-cfemail]').forEach(function (node) {
      node.textContent = "support@primegradelabs.com";
      if (node.tagName === "A") node.setAttribute("href", "mailto:support@primegradelabs.com");
      node.removeAttribute("data-cfemail");
    });
    Array.prototype.forEach.call(document.querySelectorAll("a,span,div,p"), function (node) {
      if (!node.children.length && /^\s*\[?email protected\]?\s*$/i.test(node.textContent || "")) {
        node.textContent = "support@primegradelabs.com";
        if (node.tagName === "A") node.setAttribute("href", "mailto:support@primegradelabs.com");
      }
    });
  }

  function wireAccordions() {
    document.addEventListener("click", function (event) {
      var trigger = event.target.closest('[data-faq-trigger], .question-line, [class*="faq-question"]');
      if (!trigger) return;
      var item = trigger.closest('[data-faq-item], [class*="faq-item"], li, section, .item');
      if (!item) return;
      var answer = item.querySelector('[data-faq-answer], [class*="faq-answer"], .answer');
      if (!answer) return;
      var open = item.classList.toggle("is-open");
      answer.hidden = !open;
      trigger.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  function start() {
    carryTracking();
    repairProtectedEmail();
    wireAccordions();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
